/* file is overwritten for web components */

import {Language, DefaultLanguage, getLanguage} from './language-base';

export {Language, DefaultLanguage, getLanguage};

export default getLanguage(window.location.pathname);
